module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "can-cancel": true,
      "on-cancel": _vm.onCancel,
      "is-full-page": _vm.fullPage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('h3', [_c('strong', [_vm._v("Update Accident Information")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "account-box"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputName"
    }
  }, [_vm._v("Accident Name: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentName),
      expression: "accidentName"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputName"
    },
    domProps: {
      "value": (_vm.accidentName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accidentName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Accident Type: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.accidentTypeSelect
    },
    model: {
      value: (_vm.accidentTypeSelect),
      callback: function($$v) {
        _vm.accidentTypeSelect = $$v
      },
      expression: "accidentTypeSelect"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Accident Location: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accidentLocation),
      expression: "accidentLocation"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "inputPassword"
    },
    domProps: {
      "value": (_vm.accidentLocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accidentLocation = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "example-datepicker"
    }
  }, [_vm._v("Date of Accident: ")]), _vm._v(" "), _c('date-picker', {
    staticClass: "mb-2",
    attrs: {
      "id": "example-datepicker"
    },
    model: {
      value: (_vm.dateValue),
      callback: function($$v) {
        _vm.dateValue = $$v
      },
      expression: "dateValue"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "example-timepicker"
    }
  }, [_vm._v("Time of accident: ")]), _vm._v(" "), _c('time-picker', {
    attrs: {
      "format": "hh:mm A",
      "locale": "en"
    },
    model: {
      value: (_vm.timeValue),
      callback: function($$v) {
        _vm.timeValue = $$v
      },
      expression: "timeValue"
    }
  }), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Additional Accident Information: ")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 4,
      "id": "inputPassword",
      "placeholder": _vm.additionalInfoTextArea
    },
    model: {
      value: (_vm.additionalInfoTextArea),
      callback: function($$v) {
        _vm.additionalInfoTextArea = $$v
      },
      expression: "additionalInfoTextArea"
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('strong', [_vm._v("Please select the Make and Model of your Vehicle:")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Make")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.makeValue
    },
    on: {
      "change": function($event) {
        return _vm.updateModelDropdown()
      }
    },
    model: {
      value: (_vm.makeValue),
      callback: function($$v) {
        _vm.makeValue = $$v
      },
      expression: "makeValue"
    }
  }, _vm._l((this.makeOptions), function(item) {
    return _c('el-option', {
      key: item.brand,
      attrs: {
        "label": item.brand,
        "value": item.brand
      }
    })
  }), 1), _vm._v(" "), _c('h4', [_vm._v("Model")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.modelValue,
      "disabled": _vm.modelOptions.length === 0
    },
    model: {
      value: (_vm.modelValue),
      callback: function($$v) {
        _vm.modelValue = $$v
      },
      expression: "modelValue"
    }
  }, _vm._l((this.modelOptions), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1), _vm._v(" "), _c('h4', [_vm._v("Year")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": _vm.yearValue
    },
    model: {
      value: (_vm.yearValue),
      callback: function($$v) {
        _vm.yearValue = $$v
      },
      expression: "yearValue"
    }
  }, _vm._l((_vm.yearOptions), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h4', [_c('strong', [_vm._v("Services Needed")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Please select the service(s) you would like to receive for your accident:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "overflow": "auto"
    },
    model: {
      value: (_vm.servicesNeededCheckList),
      callback: function($$v) {
        _vm.servicesNeededCheckList = $$v
      },
      expression: "servicesNeededCheckList"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Have medical services assist you with your injuries.",
      "placement": "top"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Medical"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "Towing"
    }
  }), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Get legal assistance to help with your auto accident.",
      "placement": "top"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Legal"
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Rent a vehicle to get around in the meanwhile.",
      "placement": "top"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Car Rental Service"
    }
  })], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Look for a new vehicle.",
      "placement": "top"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "Auto-Dealership"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Vehicle Speed (in MPH): ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-slider', {
    attrs: {
      "show-input": ""
    },
    model: {
      value: (_vm.vehicleSpeedValue),
      callback: function($$v) {
        _vm.vehicleSpeedValue = $$v
      },
      expression: "vehicleSpeedValue"
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Uploaded File(s)")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools pull-right"
  }, [_c('button', {
    staticClass: "btn btn-box-tool",
    attrs: {
      "type": "button",
      "data-widget": "collapse",
      "data-toggle": "tooltip",
      "title": "Collapse"
    }
  }, [_c('i', {
    staticClass: "ti-minus"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "id": "uploadedFileList",
      "empty-text": "No files uploaded.",
      "data": _vm.uploadedFileList
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "File Name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "bold"
        }, [_c('i', {
          staticClass: "dripicons-document-new"
        }), _vm._v("  " + _vm._s(scope.row.fileName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Date Uploaded"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                         " + _vm._s(scope.row.dateUploaded) + "\n                         ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Options"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('a', [_c('i', {
          staticClass: "material-icons",
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.downloadFile(props.row.filePath, props.row.fileName, props.row.contentType)
            }
          }
        }, [_vm._v("file_download")])]), _vm._v("  "), _c('a', [_c('i', {
          staticClass: "material-icons",
          on: {
            "click": function($event) {
              return _vm.deleteFile(props.row.filePath, props.row.fileName, props.row.fileId)
            }
          }
        }, [_vm._v("delete")])])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box-footer "
  }, [_c('div', {
    staticClass: "box-body",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "list-type": "picture",
      "auto-upload": false,
      "on-remove": _vm.handleRemove,
      "file-list": _vm.fileList,
      "on-preview": _vm.handlePreview,
      "on-success": _vm.handleSuccess,
      "http-request": _vm.uploadFiles,
      "multiple": true,
      "on-error": _vm.handleError,
      "on-change": _vm.handleChange,
      "before-upload": _vm.beforeUpload,
      "limit": 10,
      "on-exceed": _vm.handleExceed
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("Select New File(s) to Upload")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("Media files with a size less than 10Mb(limit of 10 files)")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "title": _vm.fileNameSelected
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.fileList.length > 0),
      expression: "this.fileList.length > 0"
    }],
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFiles()
      }
    }
  }, [_vm._v("Upload "), _c('span', [_vm._v(_vm._s(this.fileList.length))]), _vm._v(" File"), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.fileList.length > 1),
      expression: "this.fileList.length > 1"
    }]
  }, [_vm._v("s")])])], 1)])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 row-block"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v("Save Changes")])]), _vm._v(" "), _c('hr')])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-be5b17c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditAccident.vue
// module id = 1324
// module chunks = 2